import { render } from "./ModelFrame.vue?vue&type=template&id=17e7f988&scoped=true"
import script from "./ModelFrame.vue?vue&type=script&lang=js"
export * from "./ModelFrame.vue?vue&type=script&lang=js"

import "./ModelFrame.vue?vue&type=style&index=0&id=17e7f988&scoped=true&lang=scss"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17e7f988"]])

export default __exports__